import React, { useState } from "react";
import productsData from "../json/products.json";
import "./css/Products.css";

const FILTERS = ["All", "Active", "In Testing", "In Development"];

const Products = ({ onNavigate }) => {
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered = activeFilter === "All"
    ? productsData
    : productsData.filter((p) => p.status === activeFilter);

  const counts = FILTERS.reduce((acc, f) => {
    acc[f] = f === "All"
      ? productsData.length
      : productsData.filter((p) => p.status === f).length;
    return acc;
  }, {});

  return (
    <div className="products-page">

      <div className="products-hero">
        <div className="products-hero-inner">
          <h1>Our Apps</h1>
          <p>Explore the full ecosystem of platforms built by Vyral Media Group</p>
        </div>
      </div>

      <div className="products-body">

        <div className="filter-bar">
          {FILTERS.map((f) => (
            <button
              key={f}
              className={`filter-btn${activeFilter === f ? " active" : ""}`}
              onClick={() => setActiveFilter(f)}
            >
              {f}
              <span className="filter-count">{counts[f]}</span>
            </button>
          ))}
        </div>

        <div className="products-grid">
          {filtered.map(({ id, name, tagline, description, images, status }) => {
            const statusClass = status === "Active" ? "active" : status === "In Testing" ? "testing" : "development";
            const heroImg = images?.[0] || null;

            return (
              <article
                key={id}
                className="product-card"
                onClick={() => onNavigate("productShowcase", id)}
              >
                <div className="product-card-image">
                  {heroImg ? (
                    <img src={heroImg} alt={name} />
                  ) : (
                    <div className="product-card-placeholder">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                        <rect x="3" y="3" width="18" height="18" rx="2"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                        <polyline points="21 15 16 10 5 21"/>
                      </svg>
                      <span>Preview Coming Soon</span>
                    </div>
                  )}
                  <span className={`product-badge ${statusClass}`}>{status}</span>
                </div>

                <div className="product-card-body">
                  <h2>{name}</h2>
                  {tagline && <p className="product-tagline">{tagline}</p>}
                  <p className="product-desc">{description}</p>
                </div>

                <div className="product-card-footer">
                  <span className="product-cta">View Details →</span>
                </div>
              </article>
            );
          })}
        </div>

        {filtered.length === 0 && (
          <div className="products-empty">
            <p>No apps match this filter.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;
